import { baseUrl } from '../../../App';
import handleImageError from '../../../helper/defaultImage';
import CurrentUserCard from './CurrentUserCard';
import styles from './NewLeaderboardContainer.module.css';
export default function NewLeaderboardContainer({setActiveLeaderboardName,activeLeaderboardName,leaderBoardData, rankOneData, rankTwoData, rankThreeData, currentUserData}) {
  let leaderboardNavigationName={topName:'',subName:[]};
  const isMemoryMatchList = activeLeaderboardName.includes('memory');
  const memoryMatchWinnerList = ['winner_memory','winner_y_memory','winner_memory_easy','winner_y_memory_easy','winner_memory_medium','winner_y_memory_medium','winner_memory_hard','winner_y_memory_hard'];
  // const isMemoryMatchWinnerList = memoryMatchWinnerList.includes(activeLeaderboardName);
  const isMemoryMatchWinnerList = false;
let memoryMatchList = [{winner_y_memory_hard:'গতদিনের উইনার'}]
  switch (activeLeaderboardName) {
    case 'leaderboard_wordly_bangla':
      leaderboardNavigationName = {topName:'Wordly - আজকের স্কোর',subName:[{leaderboard_wordly_bangla:'বাংলা'},{leaderboard_wordly_english:'English'}]};
      break;
    case 'leaderboard_wordly_english':
      leaderboardNavigationName = {topName:'Wordly - আজকের স্কোর',subName:[{leaderboard_wordly_bangla:'বাংলা'},{leaderboard_wordly_english:'English'}]};
      break;
    case 'leaderboard_spelling':
      leaderboardNavigationName = {topName:'Spelling Bee',subName:[{leaderboard_spelling:'আজকের স্কোর'}]};
      break;
    case 'leaderboard_memory_e':
      leaderboardNavigationName = {topName:'Memory Match - আজকের স্কোর',subName:[{leaderboard_memory_e:'Easy'},{leaderboard_memory_m:'Medium'},{leaderboard_memory_h:'Hard'}]};
      break;
    case 'leaderboard_memory_m':
      leaderboardNavigationName = {topName:'Memory Match - আজকের স্কোর',subName:[{leaderboard_memory_e:'Easy'},{leaderboard_memory_m:'Medium'},{leaderboard_memory_h:'Hard'}]};
      break;
    case 'leaderboard_memory_h':
      leaderboardNavigationName = {topName:'Memory Match',subName:[{leaderboard_memory_h:'আজকের স্কোর'}]};
      break;

    case 'winner_wordly':
      leaderboardNavigationName = {topName:'Wordly',subName:[{winner_y_wordly:'গতদিনের উইনার'}]};
      break;
    case 'winner_y_wordly':
        leaderboardNavigationName = {topName:'Wordly',subName:[{winner_y_wordly:'গতদিনের উইনার'}]};
        break;
    case 'winner_spelling':
      leaderboardNavigationName = {topName:'Spelling Bee',subName:[{winner_y_spelling:'গতদিনের উইনার'}]};
      break;
    case 'winner_y_spelling':
      leaderboardNavigationName = {topName:'Spelling Bee',subName:[{winner_y_spelling:'গতদিনের উইনার'}]};
      break;

    case 'winner_memory_easy':
      leaderboardNavigationName = {topName:'Memory Match',subName:memoryMatchList};
      break;

    case 'winner_y_memory_easy':
      leaderboardNavigationName = {topName:'Memory Match',subName:memoryMatchList};
      break;

      case 'winner_memory_medium':
      leaderboardNavigationName = {topName:'Memory Match',subName:memoryMatchList};
      break;
    case 'winner_y_memory_medium':
      leaderboardNavigationName = {topName:'Memory Match',subName:memoryMatchList};
      break;

      case 'winner_memory_hard':
      leaderboardNavigationName = {topName:'Memory Match',subName:memoryMatchList};
      break;
    case 'winner_y_memory_hard':
      leaderboardNavigationName = {topName:'Memory Match',subName:memoryMatchList};
      break;
    // case 'winner_bcs':
    //   leaderboardNavigationName = {topName:'বিসিএস কুইজ',subName:[{winner_y_bcs:'গতদিনের উইনার'},{winner_bcs:'গতসপ্তাহের উইনার'}]};
    //   break;
    // case 'winner_y_bcs':
    //   leaderboardNavigationName = {topName:'বিসিএস কুইজ',subName:[{winner_y_bcs:'গতদিনের উইনার'},{winner_bcs:'গতসপ্তাহের উইনার'}]};
    //   break;
    // Add more cases for other leaderboard types as needed
    default:
      leaderboardNavigationName={topName:'',subName:[]}
  }
  return (
    <>
    <div className={styles.container}>
      {/* Top Section - Navigation and Top 3 */}
      <div className={styles.topSection}>
        {/* Main Navigation */}
        <div className={styles.mainNav}>
          <button
            className={`${styles.mainNavButton} ${styles.mainNavActive}`}
          >
            {leaderboardNavigationName.topName}
          </button>
        </div>

        {/* Sub Navigation */}
        
          <div className={styles.subNav}>
              {
              isMemoryMatchWinnerList?leaderboardNavigationName.subName.map((subItem, index) => {
                // Create a select dropdown instead of buttons
                if (index === 0) {
                  // Only render the select once, at the first index
                  return (
                    <select
                      key="memory-match-select"
                      className={styles.subNavSelect}
                      value={activeLeaderboardName}
                      onChange={e => setActiveLeaderboardName(e.target.value)}
                    >
                      {leaderboardNavigationName.subName.map((optionItem, optionIdx) => {
                        const optionKey = Object.keys(optionItem)[0];
                        return (
                          <option key={optionKey} value={optionKey}>
                            {optionItem[optionKey]}
                          </option>
                        );
                      })}
                    </select>
                  );
                }
                return null;
              }):leaderboardNavigationName.subName.map((subItem, index) => {
                const key = Object.keys(subItem)[0];
                return (
                  <button
                    key={index}
                    className={`${styles.subNavButton} ${activeLeaderboardName === key ? styles.subNavActive : ''}`}
                    onClick={() => setActiveLeaderboardName(key)}
                  >
                    {subItem[key]}
                  </button>
                );
              })
              }
            
          </div>
      
        

        <div className={styles.topPlayers}>
          {/* Second Place */}
          <div className={styles.playerCard2}>
            <div className={styles.avatarWrapper}>
              <img
                src={
                  rankTwoData?.avatar_img
                    ? `${baseUrl}/media/${rankTwoData?.avatar_img}`
                    : require(`../../../assets/avatar/avatar${rankTwoData?.avatar_id || 1}.png`)
                }
                alt="Second"
                className={styles.avatar2}
                onError={handleImageError}
              />
              <div className={styles.crownNumber2}></div>
            </div>
            <div className={styles.dataWrapper}>
              <div className={styles.msisdn}>
                {rankTwoData?.msisdn ? `0${(rankTwoData.msisdn).toString().slice(0, 3)}****${(rankTwoData.msisdn).toString().slice(-3)}` : ''}
              </div>
              {rankTwoData?.msisdn && <div className={styles.scoreInfo}>
                {isMemoryMatchList ? <span className={styles.scoreValue}>Time</span> : <span className={styles.scoreValue}>Score: {rankTwoData?.score}</span>}
                <span className={styles.timeValue}>{rankTwoData?.time_taken}s</span>
              </div>}
            </div>
          </div>

          {/* First Place */}
          <div className={styles.playerCard1}>
            <div className={styles.avatarWrapper}>
              <img src="/crown.png" alt="Crown" className={styles.crown} />
              <img
                src={
                  rankOneData?.avatar_img
                    ? `${baseUrl}/media/${rankOneData?.avatar_img}`
                    : require(`../../../assets/avatar/avatar${rankOneData?.avatar_id || 1}.png`)
                }
                alt="First"
                className={styles.avatar1}
                onError={handleImageError}
              />
              <div className={styles.crownNumber}></div>
            </div>
            <div className={styles.dataWrapper} style={{ bottom: '24px' }}>
              <div className={styles.msisdn} style={{ fontSize: '14px', fontWeight: '500' }}>
                {rankOneData?.msisdn ? `0${(rankOneData.msisdn).toString().slice(0, 3)}****${(rankOneData.msisdn).toString().slice(-3)}` : ''}
              </div>
              {rankOneData?.msisdn && <div className={styles.scoreInfo}>
                {isMemoryMatchList ? <span className={styles.scoreValue} style={{ fontSize: '16px', fontWeight: '700' }}>Time</span> : <span className={styles.scoreValue} style={{ fontSize: '16px', fontWeight: '700' }}>Score: {rankOneData?.score}</span>}
                <span className={styles.timeValue} style={{ fontSize: '12px', fontWeight: '500' }}>{rankOneData?.time_taken}s</span>
              </div>}
            </div>
          </div>

          {/* Third Place */}
          <div className={styles.playerCard3}>
            <div className={styles.avatarWrapper}>
              <img
                src={
                  rankThreeData?.avatar_img
                    ? `${baseUrl}/media/${rankThreeData?.avatar_img}`
                    : require(`../../../assets/avatar/avatar${rankThreeData?.avatar_id || 1}.png`)
                }
                alt="Third"
                className={styles.avatar3}
                onError={handleImageError}
              />
              <div className={styles.crownNumber3}></div>
            </div>
            <div className={styles.dataWrapper}>
              <div className={styles.msisdn}>
                {rankThreeData?.msisdn ? `0${(rankThreeData.msisdn).toString().slice(0, 3)}****${(rankThreeData.msisdn).toString().slice(-3)}` : ''}
              </div>
              {rankThreeData?.msisdn && <div className={styles.scoreInfo}>
                {isMemoryMatchList ? <span className={styles.scoreValue}>Time</span> : <span className={styles.scoreValue}>Score: {rankThreeData?.score}</span>}
                <span className={styles.timeValue}>{rankThreeData?.time_taken}s</span>
              </div>}
            </div>
          </div>
        </div>
      </div>

      {/* Replace the current user section with the new component */}
      <CurrentUserCard
        currentUserData={currentUserData}
        isMemoryMatchList={isMemoryMatchList}
      />

      {/* Bottom Section - Other Users */}
      <div className={styles.otherUsersSection}>
        {leaderBoardData.map((player, index) => (
          <div key={index} className={styles.userRow}>
            <div className={styles.rank}>{player.User_Rank}</div>
            <img
              src={
                player.avatar_img
                  ? `${baseUrl}/media/${player.avatar_img}`
                  : require(`../../../assets/avatar/avatar${player.avatar_id || 1}.png`)
              }
              alt="Avatar"
              className={styles.userAvatar}
              onError={handleImageError}
            />
            <div className={styles.userInfo}>
              <div className={styles.userMsisdn}>
                {player.msisdn ? `0${(player.msisdn).toString().slice(0, 3)}****${(player.msisdn).toString().slice(-3)}` : ''}
              </div>
              <div className={styles.timeAndScore} style={{justifyContent: isMemoryMatchList ? 'flex-end' : 'space-aound'}}>
                <span>{player.time_taken}s</span>
                {!isMemoryMatchList && <span>{player.score}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
}
